import { CapabilityBuilder, FuncType } from '../../utils/permission/CapabilityBuilder';
import Map from '../../types/Map';

export const APPLICATION = 'accreditation-client';

export enum Actions {
    MANAGE = 'manage',
    CREATE = 'create',
    VIEW = 'view',
    READ = 'read',
    UPDATE =  'update',
    DELETE = 'delete'
}

export enum Subjects {
    REQUESTS = 'requests',
    REQUEST = 'request',
    BOOKING = 'booking',
    BOOKINGS = 'bookings',
    DASHBOARD = 'dashboard',
    CALENDAR = 'calendar',
    REGISTRAR_INFO = 'registrarInfo',
    TESTS = 'tests',
    TEST = 'test',
    CONTACT = 'contact',
    IP = 'ip'
}

class BasicCapability {
    protected _builder: CapabilityBuilder;

    constructor(capabilityBuilder: CapabilityBuilder) {
        this._builder = capabilityBuilder;
        this._builder.can([Actions.VIEW, Actions.READ], Subjects.BOOKINGS);
        this._builder.can([Actions.VIEW, Actions.READ], Subjects.REQUESTS);
        this._builder.can([Actions.VIEW, Actions.READ], Subjects.REQUEST);
    }

    get builder(): CapabilityBuilder {
        return this._builder;
    }
}

class TechCapability extends BasicCapability {

    constructor(capabilityBuilder: CapabilityBuilder) {
        super(capabilityBuilder);
        this._builder.can([Actions.VIEW, Actions.READ], Subjects.DASHBOARD);
        this._builder.can([Actions.VIEW, Actions.READ], Subjects.CALENDAR);
        this._builder.can([Actions.VIEW], Subjects.BOOKING);
        this._builder.can([Actions.VIEW], Subjects.REGISTRAR_INFO);
        this._builder.can([Actions.VIEW, Actions.READ], Subjects.TEST);
        this._builder.can([Actions.VIEW, Actions.READ], Subjects.TESTS);
        this._builder.can([Actions.VIEW, Actions.READ], Subjects.CONTACT);
        this._builder.can([Actions.VIEW, Actions.READ], Subjects.IP);
    }
}

class AdminTechCapability extends TechCapability {
    constructor(capabilityBuilder: CapabilityBuilder) {
        super(capabilityBuilder);

        this._builder.can([Actions.DELETE, Actions.UPDATE], Subjects.BOOKING);
        this._builder.can([Actions.UPDATE], Subjects.CONTACT);
        this._builder.can([Actions.UPDATE], Subjects.IP);
    }
}

function defineRegistyRulesFor(roles: string[]):  CapabilityBuilder {
    let capabilityBuilder = new CapabilityBuilder();
    let capability: CapabilityBuilder = capabilityBuilder;
    roles.forEach((role) => {

        switch (role) {
            case 'admin':
                capability = new AdminTechCapability(capabilityBuilder).builder;
                break;
            case 'tech':
                capability = new TechCapability(capabilityBuilder).builder;
                break;
            case 'tech-admin':
                capability = new AdminTechCapability(capabilityBuilder).builder;
                break;
            case 'user':
            case 'billing':
            case 'billing-admin':
            case 'operator':
            case 'operator-admin':
            case 'legal':
            case 'legal-admin':
            case 'domain':
            case 'domain-admin':
                capability = new BasicCapability(capabilityBuilder).builder;
                break;
            default:
                break;

        }
    });

    return capability;
}

function defineRegistrarRulesFor(roles: string[]):  CapabilityBuilder {
    let capabilityBuilder = new CapabilityBuilder();

    roles.forEach((role) => {

        switch (role) {
            case 'admin':
                capabilityBuilder.can([Actions.READ], Subjects.BOOKINGS);
                capabilityBuilder.can([Actions.VIEW, Actions.READ], Subjects.REQUESTS);
                capabilityBuilder.can([Actions.VIEW, Actions.READ], Subjects.REQUEST);
                capabilityBuilder.can([Actions.VIEW, Actions.DELETE, Actions.UPDATE], Subjects.BOOKING);
                capabilityBuilder.can([Actions.VIEW], Subjects.REGISTRAR_INFO);
                capabilityBuilder.can([Actions.VIEW, Actions.READ], Subjects.TEST);
                capabilityBuilder.can([Actions.VIEW, Actions.READ], Subjects.TESTS);
                capabilityBuilder.can([Actions.VIEW, Actions.READ, Actions.UPDATE], Subjects.CONTACT);
                capabilityBuilder.can([Actions.VIEW, Actions.READ, Actions.UPDATE], Subjects.IP);
                break;
            case 'billing':
            case 'billing-admin':
            case 'domain':
            case 'domain-admin':
                break;
            case 'tech-admin':
            default:
                break;

        }
    });

    return capabilityBuilder;
}

export const RealmRules: Map<FuncType> = {
    registry: defineRegistyRulesFor,
    registrar: defineRegistrarRulesFor
};